import { __spreadArrays } from "tslib";
import React, { useMemo, useRef } from 'react';
import { Waypoint } from 'react-waypoint';
import useDuperbrowseScrollRestoration from '../../Duperbrowse/hooks/useDuperbrowseScrollRestoration';
import s from '../Torpedo.scss';
export var HiddenRow = function (_a) {
    var strip = _a.strip, onNearHidden = _a.onNearHidden;
    var itemIds = useMemo(function () {
        return strip.groups
            .reduce(function (prev, current) { return __spreadArrays(prev, current.items); }, [])
            .map(function (item) {
            return item.dto.duperbrowseItemId;
        });
    }, [strip]);
    var rowRef = useRef(null);
    useDuperbrowseScrollRestoration(itemIds, rowRef);
    return (React.createElement(Waypoint, { topOffset: '-100%', bottomOffset: '-100%', onEnter: onNearHidden, fireOnRapidScroll: false },
        React.createElement("div", { className: s['strip'], style: {
                width: strip.width,
                height: strip.lastGroup.totalHeight + (strip.extraItemHeight || 0),
            }, ref: rowRef })));
};
HiddenRow.displayName = 'HiddenRow';
export default HiddenRow;
//# sourceMappingURL=HiddenRow.js.map